<template>
  <div class="py-2 pr-3">
    <ContactForm
      v-model:contact="contact"
      :errors="errors"
      :role-is-disabled="!!roleId"
    />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import ContactForm from '@ui/modal/contact/components/ContactForm'

export default {
  name: 'SelectContactForm',
  components: { ContactForm },
  props: {
    contactId: {
      type: String,
      required: false,
      default: null
    },
    roleId: {
      type: String,
      required: false,
      default: null
    },
    onContactUpdated: {
      type: Function,
      required: false,
      default: null
    }
  },
  emits: ['contact-added', 'contact-updated'],
  data() {
    return {
      contact: null,
      isSaving: false
    }
  },
  computed: {
    ...mapGetters({
      errors: 'auth/getErrors'
    })
  },
  mounted() {
    if (this.contactId) {
      this.processFetchContactByIdAction({
        contact_id: this.contactId
      }).then((response) => {
        this.contact = response.contact
      })
    } else {
      this.processFetchNewContactAction().then((response) => {
        this.contact = {
          ...response.contact,
          roleId: this.roleId
        }
      })
    }
  },
  methods: {
    ...mapActions({
      processFetchContactByIdAction: 'contact/fetchContactById',
      processFetchNewContactAction: 'contact/fetchNewContact',
      processUpdateContactAction: 'contact/updateContact',
      processStoreNewContactAction: 'contact/storeNewContact',
      processRefreshSpecificInitialMetadataModelsAction:
        'metadata/refreshSpecificInitialMetadataModels'
    }),
    async save() {
      if (this.isSaving) return

      this.isSaving = true
      try {
        if (this.contact.id) {
          await this.processUpdateContactAction({
            id: this.contact.id,
            contact: this.contact
          }).then((response) => {
            this.$h.toastSuccess(this.$t('toasts.updated'))
            this.$emit('contact-updated', response.contact)
            // this.onContactUpdated?.(this.contact)
            this.processRefreshSpecificInitialMetadataModelsAction({
              model: 'contacts'
            })
          })
        } else {
          await this.processStoreNewContactAction({
            contact: this.contact
          }).then((response) => {
            this.$h.toastSuccess(
              this.$t('toasts.created_m', {
                var: this.$t('attributes.contact')
              })
            )
            this.$emit('contact-updated', response.contact)
            this.processRefreshSpecificInitialMetadataModelsAction({
              model: 'contacts'
            })
          })
        }
      } finally {
        this.isSaving = false
      }
    }
  }
}
</script>
